import {
  blue,
  blueGrey,
  common,
  deepOrange,
  green,
  grey,
  lightBlue,
  lightGreen,
  orange,
  pink,
  purple,
  red,
  teal,
  yellow,
} from './colors';

export const palette = {
  type: 'light',
  common,
  primary: {
    main: blue[800],
    dark: blue[900],
    light: blue['A50'],
    contrastText: common.white,
  },
  secondary: {
    main: grey['A100'],
    dark: blueGrey['A100'],
    light: grey['A100'],
    contrastText: blueGrey[900],
  },
  error: {
    main: pink[700],
    dark: deepOrange[900],
    light: deepOrange[50],
    contrastText: common.white,
  },
  warning: {
    main: orange[400],
    dark: orange[800],
    light: orange[300],
    contrastText: deepOrange[900],
  },
  info: {
    main: blue[800],
    dark: blue[900],
    light: blue['A50'],
  },
  success: {
    main: teal[700],
    dark: teal[500],
    light: teal[50],
    contrastText: teal[900],
  },
  danger: {
    main: pink[700],
    dark: deepOrange[900],
    light: deepOrange[50],
    contrastText: common.white,
  },
  text: {
    primary: blueGrey[900],
  },
  background: {
    paper: common.white,
    default: grey[50],
  },
  divider: grey['A100'],
  orange,
  deepOrange,
  pink,
  red,
  purple,
  blue,
  lightBlue,
  teal,
  green,
  lightGreen,
  yellow,
  grey,
  blueGrey,
} as const;
